import axios from 'axios';
import axiosUrl from './axios.service';
import store from '../store/index';

const API_URL = axiosUrl.getAxiosUrl();

class AuthService {
    login(user) {
        return axios
            .post(API_URL + '/users/authenticate', {
                // username: user.username,
                email: user.email,
                password: user.password
            })
            .then(response => {
                if (response.data.token) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }

                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');
    }

    getEnvironment() {
        return axios
            .get(API_URL + '/users/getEnvironment')
            .then((response) => {
                store.commit('auth/setEnvironment', response.data);
            });
    }

    async getPortalInfo() {
        return await axios
            .get(API_URL + '/users/getPortalInfo')
            .then((response) => {
                store.commit('auth/setCustomerPortalName', response.data.customerPortalName);
            });
    }

    async register(user) {
        return await axios
            .post(API_URL + '/users/register', {
                firstName: user.firstName,
                lastName: user.lastName,
                portalOrganisation: user.organisation,
                email: user.email,
            });
    }    
}

export default new AuthService();